module.exports = "/_next/static/images/TSVM-a83f98d23d1f12091b671e799e353d10.svg";